export default {"src":"/_next/static/media/arrow-up-black.b5e825e0.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};